export default __webpack_public_path__ + "assets/fonts/ae307076ed392fdbfeb1ae203e999e49.woff";